import React, { Component } from "react";
import SmartUIOffer from "@ali/smart-ui-offer";
import classnames from "classnames";
import Util from "../../../pages/util/common"
import { sendWW } from "../../../service";
import { offerClickLog } from "../../../goldlog";

const obj = Util.getUrlParms();
const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};
class Offer extends Component {
  constructor(props) {
    super(props);
    this.handleOfferCardClick = this.handleOfferCardClick.bind(this);
  }

  handleOfferCardClick() {
    const { data } = this.props;
    try {
      const isLoginId = Util.getCookie("__cn_logon_id__");
      const cookieCna = Util.getCookie("cna");

      offerClickLog({
        cna: cookieCna || '',
        offerId: data.offerId,
        isLogin: !!isLoginId,
        from: 'PCSearchPage_pcSme',
        position: 'offerCard'
      });
    } catch (error) {
      // 数据上报失败，不做处理
    }
  }

  render() {
    const { data, index, buyerTags } = this.props;
    let cbu_ad_sessionid = "";
    let cbu_ad_adgroup_id = "";
    //兼容垃圾数据
    if (!data.attr.tradePrice) {
      return <div />;
    }

    const isp4p = data.p4P || data.isP4P ? 1 : 0;

    const { imgUrl } = data;
    if (imgUrl.indexOf("cbu01.alicdn.com") > -1 && !/220x220/.test(imgUrl)) {
      // imgUrl = `${imgUrl}?_=2020`;
      data.imgUrl = `${imgUrl.replace(".jpg", ".220x220.jpg")}?_=2020`;
    }

    const style = {
      width: "222px",
      height: "322px",
      boxSizing: "border-box",
      position: "relative",
      marginRight: "11px",
      marginBottom: "11px",
    };

    //data.isPcSem = true;
    //delete data.loginId;
    //添加打点参数
    let { trackInfo } = data;
    if (trackInfo && typeof trackInfo === "string") {
      trackInfo = JSON.parse(trackInfo);
    } else if (!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;

    const wwClick = () => {
      const { exp } = pageConfig;
      let expParams = getExpParams(exp || "");
      window.Light && window.Light.setup({
        beforeOpenClient: (_targetElement, urlParamObj, next) => {
          urlParamObj.sourceValue = encodeURIComponent(
            JSON.stringify({
              sourceType: "pcOD",
              targetLoginId: data.loginId,
              source: "od",
              offerId: data.offerid,
              orderId: "",
              adClickId: Util.getUrlParam('clickid'),
              extra: { cosite: Util.getUrlParam('cosite'), pid: Util.getUrlParam('pid'), ptid: Util.getUrlParam('ptid') },
            })
          );
          next(urlParamObj);
        },
      });
      if (Util.getCookie("__cn_logon_id__") && isp4p && expParams.pcSemWwClick === "B") {
        sendWW(data.eurl, data.offerid, "user_trigger")
      }
    }
    if (!data.loginId && data.attr && data.attr.aliTalk) {
      data.loginId = data.attr.aliTalk.loginId;
    }

    // 实验逻辑不影响主链路
    let lantu_ab = 'a';
    const { exp } = pageConfig;
    const expParams = getExpParams(exp || "");
    if (expParams.lantu && expParams.lantu === "B") {
      lantu_ab = 'b';
      try {
        const q = (window.aplus_queue || (window.aplus_queue = []));
        q.push({
          'action': 'aplus.record',
          'arguments': ['/media.main_image.bucket_b', 'EXP', `offerId=${data.offerid}`, 'POST']
        });
      } catch (error) {
        console.log('B曝光出错');
      }
      return (
        <div
          className={classnames({
            offer_exp: data.impressionEurl,
          })}
          data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
          data-tracker="offer"
          // eslint-disable-next-line react/prop-types
          data-aplus-report={`object_type@offer^object_id@${data.offerid}^_p_isad@${isp4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}^itemType@${data.itemType}^lantu_ab@${lantu_ab}`}
          style={style}
          onClick={() => {
            try {
              const q = (window.aplus_queue || (window.aplus_queue = []));
              q.push({
                'action': 'aplus.record',
                'arguments': ['/media.main_image.bucket_b', 'CLK', `offerId=${data.offerid}`]
              });
            } catch (error) {
              console.log('B点击出错');
            }
          }}
        >
          <SmartUIOffer data={data} buyerTags={buyerTags} wwClick={wwClick} />
          {
            obj._debugMode_ == 1 &&
            <div title={data.debugMark} className="debug">{data.debugMark}</div>
          }
        </div>
      )
    }

    if (expParams.lantu && expParams.lantu === "C") {
      lantu_ab = 'c';
      try {
        const q = (window.aplus_queue || (window.aplus_queue = []));
        q.push({
          'action': 'aplus.record',
          'arguments': ['/media.main_image.bucket_c', 'EXP', `offerId=${data.offerid}`, 'POST']
        });
      } catch (error) {
        console.log('C曝光出错');
      }
      return (
        <div
          className={classnames({
            offer_exp: data.impressionEurl,
          })}
          data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
          data-tracker="offer"
          // eslint-disable-next-line react/prop-types
          data-aplus-report={`object_type@offer^object_id@${data.offerid}^_p_isad@${isp4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}^itemType@${data.itemType}^lantu_ab@${lantu_ab}`}
          style={style}
          onClick={() => {
            try {
              const q = (window.aplus_queue || (window.aplus_queue = []));
              q.push({
                'action': 'aplus.record',
                'arguments': ['/media.main_image.bucket_c', 'CLK', `offerId=${data.offerid}`]
              });
            } catch (error) {
              console.log('C点击出错');
            }
          }}
        >
          <SmartUIOffer data={data} buyerTags={buyerTags} wwClick={wwClick} />
          {
            obj._debugMode_ == 1 &&
            <div title={data.debugMark} className="debug">{data.debugMark}</div>
          }
        </div>
      )
    }

    try {
      const q = (window.aplus_queue || (window.aplus_queue = []));
      q.push({
        'action': 'aplus.record',
        'arguments': ['/media.main_image.bucket_a', 'EXP', `offerId=${data.offerid}`, 'POST']
      });
    } catch (error) {
      console.log('A曝光出错');
    }
    // 实验逻辑不影响主链路

    return (
      <div
        className={classnames({
          offer_exp: data.impressionEurl,
        })}
        data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
        data-tracker="offer"
        // eslint-disable-next-line react/prop-types
        data-aplus-report={`object_type@offer^object_id@${data.offerid}^_p_isad@${isp4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}^itemType@${data.itemType}^lantu_ab@${lantu_ab}^ptid=${this.props.ptid || ''}`}
        style={style}
        onClick={() => {
          try {
            const q = (window.aplus_queue || (window.aplus_queue = []));
            q.push({
              'action': 'aplus.record',
              'arguments': ['/media.main_image.bucket_a', 'CLK', `offerId=${data.offerid}`]
            });
          } catch (error) {
            console.log('A点击出错');
          }
        }}
      >
        <SmartUIOffer data={data} buyerTags={buyerTags} wwClick={wwClick} />
        {
          obj._debugMode_ == 1 &&
          <div title={data.debugMark} className="debug">{data.debugMark}</div>
        }
      </div>
    );
  }
}

export default Offer;
